<app-menu-common url="sales"></app-menu-common>

<div class="events-page">

  <!-- =========================================================================
       BARRE D'OUTILS & FILTRES INLINE (look & feel aligné sur quotations)
       ========================================================================= -->
  <div class="toolbar-card">

    <div class="toolbar-title">
      <mat-icon class="toolbar-icon">event_note</mat-icon>
      <span>Events</span>
    </div>

    <div class="filters-inline">

      <div class="filter-item">
        <label class="filter-label" for="flt-id">N° Event</label>
        <input id="flt-id" class="custom-input input-id" type="number" [(ngModel)]="filter.id"
          (keyup.enter)="onSearch()" placeholder="ex: 308">
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-objid">N° Objet</label>
        <input id="flt-objid" class="custom-input input-id" type="number" [(ngModel)]="filter.objectid"
          (keyup.enter)="onSearch()" placeholder="ex: 621162">
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-object">Objet</label>
        <select id="flt-object" class="custom-select object-select" [(ngModel)]="filter.objecttyp"
          (change)="onSearch()">
          @for (obj of objectTypes; track obj.id) {
            <option [value]="obj.id">{{ obj.label }}</option>
          }
        </select>
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-action">Action</label>
        <select id="flt-action" class="custom-select action-select" [(ngModel)]="filter.typ"
          (change)="onSearch()">
          @for (act of eventTypes; track act.id) {
            <option [value]="act.id">{{ act.label }}</option>
          }
        </select>
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-user">Opérateur</label>
        <select id="flt-user" class="custom-select user-select" [(ngModel)]="filter.userid"
          (change)="onSearch()">
          @for (u of users; track u.id) {
            <option [value]="u.id">
              {{ ((u.firstname ?? '') + ' ' + (u.lastname ?? '')).trim() || u.login || ('#' + u.id) }}
            </option>
          }
        </select>
      </div>

      <div class="filter-item date-filter">
        <app-select-date label="Du" [date]="filter.datstart"
          (dateChange)="dateChange($event, 'datstart')"></app-select-date>
      </div>

      <div class="filter-item date-filter">
        <app-select-date label="Au" [date]="filter.datend"
          (dateChange)="dateChange($event, 'datend')"></app-select-date>
      </div>

      <div class="filter-item">
        <label class="filter-label" for="flt-limit" title="Nombre d'événements à afficher">Nb rép.</label>
        <select id="flt-limit" class="custom-select limit-select" [(ngModel)]="filter.limit"
          (change)="onSearch()">
          @for (val of limitsValue; track val) {
            <option [value]="val">{{ val }}</option>
          }
        </select>
      </div>

    </div>

    <div class="toolbar-actions">
      <button mat-stroked-button class="btn-inline btn-ghost" aria-label="Actualiser"
        title="Relancer la recherche" (click)="onSearch()">
        <mat-icon [class.spinning]="is_loading">refresh</mat-icon>
      </button>
      <button mat-flat-button class="error btn-inline" aria-label="Effacer"
        title="Réinitialiser les filtres" (click)="onCancel()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>

  </div>

  <!-- =========================================================================
       TABLEAU & ACCORDÉON DE CONSULTATION DES ÉVÉNEMENTS
       ========================================================================= -->
  <div class="table-card">

    <!-- En-tête de la carte : Titre, compteur et boutons Déplier/Replier -->
    <div class="table-header-bar">
      <div class="table-title">
        <mat-icon>history</mat-icon>
        <span>Journal des événements (c_event)</span>
        <span class="badge-count">{{ events.length }}</span>
      </div>

      <div class="table-actions">
        <button mat-button class="btn-accordion-action" (click)="expandAll()" title="Déplier tous les panneaux">
          <mat-icon>unfold_more</mat-icon>
          <span>Déplier tout</span>
        </button>
        <button mat-button class="btn-accordion-action" (click)="collapseAll()" title="Replier tous les panneaux">
          <mat-icon>unfold_less</mat-icon>
          <span>Replier tout</span>
        </button>
      </div>
    </div>

    <!-- Barre d'en-tête de colonnes visuelle pour repérage dans les panneaux -->
    <div class="events-columns-header">
      <span class="col col-id">ID</span>
      <span class="col col-date">Création</span>
      <span class="col col-proc">Traitement</span>
      <span class="col col-obj">Objet</span>
      <span class="col col-objid">ID Obj</span>
      <span class="col col-action">Action</span>
      <span class="col col-user">Opérateur</span>
      <span class="col col-summary">Aperçu payload (c_event.data)</span>
      <span class="col col-arrow"></span>
    </div>

    <!-- Accordéon des événements -->
    <mat-accordion multi="true" class="events-accordion">
      @for (item of events; track item.id) {
        <mat-expansion-panel class="event-panel">
          <mat-expansion-panel-header class="event-panel-header">
            <mat-panel-title class="event-header-row">
              <span class="col col-id">
                <span class="id-badge">#{{ item.id }}</span>
              </span>

              <span class="col col-date" [matTooltip]="item.datcre || ''">
                {{ item.datcre ? (item.datcre | date:'dd/MM/yy HH:mm:ss') : '-' }}
              </span>

              <span class="col col-proc" [class.unprocessed]="!item.datpro"
                [matTooltip]="item.datpro || 'En attente de traitement'">
                {{ item.datpro ? (item.datpro | date:'dd/MM/yy HH:mm:ss') : 'En attente' }}
              </span>

              <span class="col col-obj">
                <span class="type-badge" [ngClass]="getObjectBadgeClass(item.objecttyp)">
                  {{ getObjectTypeLabel(item.objecttyp) }}
                </span>
              </span>

              <span class="col col-objid">
                <span class="objid-badge">#{{ item.objectid }}</span>
              </span>

              <span class="col col-action">
                <span class="type-badge" [ngClass]="getEventBadgeClass(item.typ)">
                  {{ getEventTypeLabel(item.typ) }}
                </span>
              </span>

              <span class="col col-user">
                <span class="user-label" [title]="'User ID: ' + item.userid">
                  {{ item.user_login || ('#' + item.userid) }}
                </span>
              </span>

              <span class="col col-summary" [matTooltip]="getPayloadSummary(item)">
                {{ getPayloadSummary(item) }}
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- Corps de l'accordéon : consultation de c_event.data (chargé à la demande) -->
          <ng-template matExpansionPanelContent>
            <div class="panel-body">
              <div class="payload-toolbar">
                <div class="payload-title">
                  <mat-icon class="payload-icon">data_object</mat-icon>
                  <span>Payload JSON <code>c_event.data</code> &mdash; Événement #{{ item.id }}</span>
                </div>

                <div class="payload-actions">
                  <button mat-stroked-button class="btn-payload btn-pull" (click)="onPullEvent(item, $event)"
                    [disabled]="item._reloading" title="Relire l'événement complet via GET /pullevent/{id}">
                    <mat-icon [class.spinning]="item._reloading">sync</mat-icon>
                    <span>Recharger (pullevent)</span>
                  </button>

                  <button mat-stroked-button class="btn-payload" (click)="copyJson(item, $event)"
                    title="Copier le JSON dans le presse-papiers">
                    <mat-icon>{{ item._copied ? 'check' : 'content_copy' }}</mat-icon>
                    <span>{{ item._copied ? 'Copié !' : 'Copier le JSON' }}</span>
                  </button>
                </div>
              </div>

              <!-- Bloc JSON stylisé -->
              <div class="json-container">
                <pre class="json-code"><code>{{ formatJson(item.data) }}</code></pre>
              </div>
            </div>
          </ng-template>
        </mat-expansion-panel>
      } @empty {
        @if (!is_loading) {
          <div class="empty-state">
            <mat-icon class="empty-icon">search_off</mat-icon>
            <p class="empty-title">Aucun événement ne correspond aux critères sélectionnés</p>
            <p class="empty-subtitle">Modifiez vos filtres ou élargissez la période de recherche</p>
          </div>
        }
      }
    </mat-accordion>

  </div>

</div>
